import { Map } from "@iventis/mapbox-gl";
import { LayerStorageScope, MapModuleLayer } from "../../types/store-schema";
import { createLineHighlightLayer } from "../engine-generic-helpers";
import { iventisLineToBaseSublayer } from "../mapbox/engine-mapbox-helpers";
import { MapboxHighlightLayer } from "./mapbox-highlight-layer";

export class MapboxHighlightLineLayer extends MapboxHighlightLayer {
    constructor(layerId: string, map: Map) {
        super(layerId, map);
    }

    public addLayer(layer: MapModuleLayer, aboveLayerId: string) {
        let mapboxLayer = this.map.getLayer(this.layerId);
        if (mapboxLayer == null) {
            if (this.map.getSource(this.layerId) == null) {
                this.addSource();
            }
            const iventisLayer = createLineHighlightLayer({ ...layer, storageScope: LayerStorageScope.LocalOnly, source: this.layerId });
            mapboxLayer = iventisLineToBaseSublayer(iventisLayer, this.layerId);
            mapboxLayer.metadata = { name: layer.name, type: "highlight" };
            this.map.addLayer(mapboxLayer, aboveLayerId);
            this.map.setFilter(this.layerId, ["in", "id"]);
        }
    }
}
